import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DataService} from '../../services/data.service';
import moment from 'moment-timezone';
import {BehaviorSubject, Subscription} from 'rxjs';
import {AclUser} from '../../interfaces/app-user';
import {map} from 'rxjs/operators';
import {DisplayStatReport, StatField, StatReport} from '../../interfaces/stats';
import {AuthService} from '../../services/auth.service';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmationDialogComponent} from '../../components/confirmation-dialog/confirmation-dialog.component';
import {Timestamp} from 'firebase/firestore';
import {AsyncPipe, DatePipe} from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-statcollector-list',
    standalone: true,
    templateUrl: './statcollector-list.component.html',
    imports: [
        MatCardModule,
        MatIconModule,
        MatButtonModule,
        AsyncPipe,
        DatePipe,
    ],
    styleUrls: ['./statcollector-list.component.scss']
})
export class StatcollectorListComponent implements OnInit, OnDestroy {

    public reportsSub: Subscription;
    public reports: BehaviorSubject<DisplayStatReport[]> = new BehaviorSubject([]);
    private deleteSub: Subscription;
    private authSub: Subscription;
    public canDelete = false;
    @Input()
    public currentUserStatFields: Array<StatField>;

    constructor(private dataService: DataService, private authService: AuthService, private dialog: MatDialog) {
    }

    @Input()
    set selectedUser(user: AclUser) {

        console.log('selected user: ', user.email);
        this.reportsSub = this.dataService.getStatReportsList(user).pipe(
            map((reports: StatReport[]) => reports.map((r: StatReport) => {
                const incomingReport = r;

                // just show fields for current user
                this.currentUserStatFields.map(field => {
                    if (field.permissionMap.indexOf(user.email) === -1) delete incomingReport[field.name];
                });


                const report: Partial<DisplayStatReport> = {
                    id: incomingReport.id,
                    lastModifiedDate: this.extractDateFromTimestamp((incomingReport.lastModifiedDate as unknown) as Timestamp),
                    weekOfYear: moment(this.extractDateFromTimestamp((incomingReport.creationDate as unknown) as Timestamp)).isoWeek(),
                    fields: []
                };
                Object.keys(incomingReport).forEach(key => {
                    const field = this.currentUserStatFields.find(f => f.name === key);
                    if (!field) return;
                    report.fields.push({
                        key: key,
                        value: incomingReport[key],
                        description: field.description,
                        hint: field.hint,
                        name: field.name,
                        show: true,
                        isManual: field.isManual
                    });
                });

                // sort
                report.fields = report.fields.sort((a, b) => a.description > b.description ? 1 : -1);
                return report as DisplayStatReport;
            }))).subscribe(this.reports);
    }

    ngOnInit() {
        this.authSub = this.authService.userHasPermission('app.stats.delete').subscribe(p => this.canDelete = p);
    }


    deleteRow(row: DisplayStatReport) {
        const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            width: '350px',
            data: {title: 'Confirm deletion', message: `Are you sure you want to delete this report?`}
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                console.log('deleting:', row);
                if (!row.id) return;
                this.deleteSub = this.dataService.deleteStatReport(row.id)
                    .subscribe(() => console.log('report deleted'));
            }
        });
    }


    public ngOnDestroy() {
        if (this.reportsSub) this.reportsSub.unsubscribe();
        if (this.deleteSub) this.deleteSub.unsubscribe();
        if (this.authSub) this.authSub.unsubscribe();
    }

    extractDateFromTimestamp(date: Timestamp) {
        if (!date) return undefined;
        return date.toDate();
    }
}
